<template>
  <div class="task">
    <page-loader v-if="!isLoaded"></page-loader>
    <div class="theory-btn">
      <button class="btn btn-default btn-back" v-on:click="nextToTaskTheory"><i
        class="fas fa-angle-left"></i> Theory
      </button>
    </div>
    <help-button :task-help-info="task.helpInfo"></help-button>

    <div class="playground">
      <task-playground-preview :task-id="id"></task-playground-preview>

      <div class="task-text">
        <span v-html="task.taskString" v-if="taskPlayground"></span>
        <skeleton-box v-else width="325px" height="48px"></skeleton-box>
      </div>

      <workflow-area :taskId="id">
        <skeleton-box v-if="!task.name" width="325px" height="81px"></skeleton-box>
      </workflow-area>
    </div>
  </div>
</template>

<script>
    import {
        GET_TASK,
        TASK_PLAYGROUND_REQUEST,
        TASK_REQUEST,
        USER_TASK_START
    } from "../../../store/actions/task";
    import {GET_COURSE} from "../../../store/actions/course";
    import {TaskFilter} from "../../../models/taskFilter";

    import HelpButton from "../../../components/task/HelpButton";
    import SkeletonBox from "../../../components/SkeletonBox";
    import PreviewFrame from "../../../components/task/PreviewFrame";
    import WorkflowArea from "../../../components/task/WorkflowArea";
    import TaskPlaygroundPreview from "./TaskPlaygroundPreview";
    import PageLoader from "../../../components/PageLoader";

    export default {
        name: 'Workflow',
        components: {
            TaskPlaygroundPreview,
            HelpButton,
            WorkflowArea,
            PreviewFrame,
            SkeletonBox,
            PageLoader
        },
        props: ['courseId', 'id'],
        data() {
            return {
                isLoaded: false,
                course: {
                    name: ''
                },
                task: {
                    level: '',
                    name: '',
                    taskString: ''
                },
                taskPlayground: {
                    id: null
                }
            }
        },
        created() {
            this.$store.dispatch(TASK_REQUEST, new TaskFilter({
                courseId: this.courseId
            }));

            if (!this.$store.getters.getCurrentUserTask){
                this.isLoaded = true;
                this.$store.dispatch(USER_TASK_START, this.id);
            }
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getTasks,
                (tasks) => {
                    this.prepareData(tasks);
                },
            );
        },
        methods: {
            prepareData(tasks) {
                if (tasks.length <= 0) return;

                this.task = tasks.find(task => task.id === this.id);
                this.isLoaded = true;
            },
            nextToTaskTheory() {
                this.$router.push({
                    name: 'TaskTheory',
                    params: {
                        courseId: this.courseId,
                        id: this.id
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
